import { Skeleton } from "ui";

type SkeletonTextProps = {
  /** Number of text lines to render. */
  lines?: number;
  /** Extra classes applied to every line. */
  className?: string;
  /** Force every line to 100% width, overriding the tapering default. */
  fullWidth?: boolean;
};

const WIDTHS = [100, 92, 80, 66];

export const SkeletonText = ({
  lines = 1,
  className,
  fullWidth = false,
}: SkeletonTextProps) => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className={className}
        style={{ width: `${fullWidth ? 100 : WIDTHS[i % WIDTHS.length]}%` }}
      />
    ))}
  </div>
);
